/**
 * @constant {Number} - Level 4 User
 */
export const ADMIN_ACCESS_LEVEL = 4;

/**
 * @constant {Number} - Level 3 User
 */
export const OWNER_ACCESS_LEVEL = 3;


export const hasPathAccess = (navItems, targetPath) => {
	return navItems.some(item => {
		if (item.path === targetPath) return true;
		if (Array.isArray(item.subItems)) {
			return item.subItems.some(sub => sub.path === targetPath);
		}
		return false;
	});
};
